import React from "react";
import { Plus } from "lucide-react";
import { photoUrl, peso } from "./lib";

function Photo({ p, className }) {
  return p.photos?.[0]
    ? <img className={`sf-img ${className || ""}`} src={photoUrl(p.photos[0])} alt={p.name} loading="lazy" decoding="async" width="600" height="450" />
    : <div className={`sf-img ${className || ""}`} style={{ aspectRatio: "4/3" }} />;
}

function SoldOut({ p }) {
  return p.soldOut ? <span className="sf-soldout" data-testid={`sf-soldout-${p.id}`}>sold out</span> : null;
}

// Counter — food, big two-up photos, large prices.
export function CounterTemplate({ products, onOpen, onAdd }) {
  return (
    <div className="sf-grid counter" data-testid="sf-template-counter">
      {products.map((p) => (
        <div key={p.id} className="sf-card" data-testid={`sf-item-${p.id}`}>
          <div style={{ position: "relative" }} onClick={() => onOpen(p)} role="button">
            <SoldOut p={p} /><Photo p={p} />
          </div>
          <div className="sf-body">
            <h3 className="sf-name" onClick={() => onOpen(p)} role="button">{p.name}</h3>
            <div className="sf-price">{p.price}</div>
            {p.description ? <p className="sf-desc sf-muted">{p.description}</p> : null}
            <button className="sf-btn primary" disabled={p.soldOut} data-testid={`sf-add-${p.id}`}
              onClick={() => (p.variants.length ? onOpen(p) : onAdd(p, null))}>
              {p.variants.length ? "choose" : <><Plus size={15} /> add</>}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

// Rack — goods, dense four-up, sizes and colours visible.
export function RackTemplate({ products, onOpen }) {
  return (
    <div className="sf-grid rack" data-testid="sf-template-rack">
      {products.map((p) => (
        <div key={p.id} className="sf-card" data-testid={`sf-item-${p.id}`} onClick={() => onOpen(p)} role="button">
          <div style={{ position: "relative" }}><SoldOut p={p} /><Photo p={p} /></div>
          <div className="sf-body">
            <h3 className="sf-name">{p.name}</h3>
            <div className="sf-price">{p.price}</div>
            {p.variants.length ? (
              <div className="sf-vars">
                {p.variants.slice(0, 4).map((v) => <span key={v.name} className="sf-vtag">{v.name}</span>)}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}

// Single — one hero product with the story, then the rest small.
export function SingleTemplate({ products, onOpen, onAdd }) {
  if (!products.length) return null;
  const hero = products[0], rest = products.slice(1);
  return (
    <div className="sf-single" data-testid="sf-template-single">
      <div className="sf-card sf-hero" data-testid={`sf-item-${hero.id}`}>
        <div style={{ position: "relative" }}><SoldOut p={hero} /><Photo p={hero} /></div>
        <div className="sf-hero-body">
          <h1 className="sf-name">{hero.name}</h1>
          <div className="sf-price">{hero.price}</div>
          {hero.description ? <p className="sf-story">{hero.description}</p> : null}
          <button className="sf-btn primary block" disabled={hero.soldOut} data-testid={`sf-add-${hero.id}`}
            onClick={() => (hero.variants.length ? onOpen(hero) : onAdd(hero, null))}>
            {hero.variants.length ? "choose options" : "add to basket"}
          </button>
        </div>
      </div>
      {rest.length ? (
        <>
          <div className="sf-rest-title">More from this shop</div>
          <div className="sf-rest">
            {rest.map((p) => (
              <div key={p.id} className="sf-card" data-testid={`sf-item-${p.id}`} onClick={() => onOpen(p)} role="button">
                <div style={{ position: "relative" }}><SoldOut p={p} /><Photo p={p} /></div>
                <div className="sf-body"><h3 className="sf-name">{p.name}</h3><div className="sf-price">{p.price}</div></div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}

export const TEMPLATE_MAP = { counter: CounterTemplate, rack: RackTemplate, single: SingleTemplate };
